import type { RootState } from '@appStore/store'

import './style.scss'

import type { useTempProps } from 'pages/team/statistics/temp'

import Checkbox from '@mui/material/Checkbox'
import CircularProgress from '@mui/material/CircularProgress'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { teams } from 'actions/teams'
import { api } from 'api/api'
import { linkedInProfileOpener } from 'api/linkedInProfileOpener'
import avatarSvg from 'assets/image/icons/svg/user.svg'
import iconArrow from 'assets/image/icons/tables/arrow-rigth.svg'
import selectedCheckboxIcon from 'assets/image/icons/tables/checkbox2.svg'
import partiallySelectedCheckboxIcon from 'assets/image/icons/tables/checkbox3.svg'
import notSelectedCheckboxIcon from 'assets/image/icons/tables/checkbox.svg'
import linkSvgGold from 'assets/image/icons/tables/goldLink.svg'
import clsx from 'clsx'
import { PaginationWrapper } from 'components/atoms/mTablePagination/PaginationWrapper'
import { CONSTS } from 'config/objectConst'
import { campaignConst, campaignUtils } from 'features/campaigns'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { notifyError } from 'shared/errors'
import { Button, StackIcon } from 'shared/ui'
import { functions, saveData } from 'tools/functions'

import { appSelectors } from '../../../redux/reducers/app'
import ExportToCSVButton from '../../atoms/ExportToCSVButton'
import TooltipCustom from '../../atoms/tooltipCustom'
import { FiltersTeam } from '../../organisms/filtersTeam'
import { buildStatus } from '../buildStatusCampaign'
import CampaignFiltersTeams from '../CampaignFiltersTeams'
import { InformationalTip } from '../InformationalTip/InformationalTip'
import SortIconCampaigns from '../personalCampaignsStatistics/sortIconsCampaigns'
import { PersonLink } from './PersonLink'
import css from './style.module.css'

type Props = any &
	ReturnType<typeof mapStateToProps> &
	ReturnType<typeof useTempProps>

export class TeamCampaignStatistics extends Component<Props, any> {
	constructor(props: any) {
		super(props)
		this.state = {
			campaignIdWithTip: '',
			filtersController: false,
			filtersTeams: null,
			initialFilters: this.createInitialState(),
			initialFiltersLocale: this.createInitialState(),
			isIconActive: {
				acceptance_rate: true,
				currentId: null,
				invitation_sent: true,
				messages_sent: true,
				name: true,
				persona_id: true,
				reply_rate: true,
				started: false,
				started_count: true
			},
			loader: false,
			page: 0,
			rowsPerPage: CONSTS.PAGE_SIZE,
			scrollBarWidth: false,
			selectAllCampaignsValue: false,
			selected: [],
			selectedValues: 0,
			showAll: false
		}
		this.wrapper = React.createRef()
	}

	clearAllFilters = async () => {
		await this.setState({
			initialFilters: this.createInitialState()
		})
		this.setState({
			initialFiltersLocale: this.createInitialState()
		})
		this.getCampaignsTeam()
	}

	clearFilter = async id => {
		const idx = this.state.initialFilters.findIndex(el => el.id === id)
		if (id === 3) {
			this.state.initialFilters[idx].value = ''
		} else {
			this.state.initialFilters[idx].value = []
		}

		this.setState({
			initialFilters: this.state.initialFilters
		})
		this.setState({
			initialFiltersLocale: structuredClone(this.state.initialFilters)
		})

		this.getCampaignsTeam()
	}
	clearFilterController = value => {
		this.setState({ clearFilterData: value })
	}

	componentDidMount() {
		this.getCampaignsTeam()
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.orderby !== prevProps?.orderby) {
			this.getCampaignsBySort()
		}
		this.handleResize()
	}

	createFiltersData = () => {
		const executionsFilter = this.state.initialFilters.find(
			val => val.name === 'Show Campaigns'
		).value

		const filters = this.state.initialFilters
			.filter(el => el.name !== 'Show Campaigns')
			.map(el => {
				const res = el.value.map(val => val.value).join(',')
				return el.name === 'members' && res.length > 0
					? `persona_id in (${res})`
					: el.name === 'status' && res.length > 0
						? `state in (${res})`
						: res
			})

		if (executionsFilter.length > 0) {
			filters.push(`statistics/${executionsFilter} and state ne 'Compose'`)
		}

		return filters
	}

	createInitialState = () => {
		return [
			{
				id: 1,
				name: 'status',
				search: false,
				tag: '',
				value: []
			},
			{
				id: 2,
				name: 'members',
				search: false,
				tag: '',
				value: []
			},
			{
				id: 3,
				name: 'Show Campaigns',
				search: false,
				tag: '',
				value: ''
			}
		]
	}
	exportCampaigns = async () => {
		const filtersData = this.createFiltersData()
		const currentFilter = filtersData
			? filtersData.filter(el => el.length > 0).join(' and ')
			: ''
		const selectId = this.state.selected

		try {
			this.setState({ isLoadingCSV: true })
			const response = await api.exportCampaignsTeamApi({
				archived: false,
				filter: this.state.selectAllCampaignsValue
					? currentFilter
					: `id in (${selectId.map(item => `'${item}'`)})`,
				keywords: this.state.selectAllCampaignsValue
					? this.props.searchValue
					: '',
				orderby: this.props.orderby
			})
			if (response.status === 200) {
				const data = response.data,
					fileName = functions.getFileName()
				saveData(data, fileName)
			}
		} catch (error) {
			notifyError(error)
		}
		this.setState({
			selected: []
		})
		this.setState({ isLoadingCSV: false })
		this.setState({
			selectAllCampaignsValue: false
		})
	}
	filtersControllerToggle = () => {
		this.setState({
			filtersController: !this.state.filtersController
		})
	}

	getCampaignsBySort = async newPage => {
		const filtersData = this.createFiltersData()
		this.props.setLoaderStatistics(true)
		await teams.getCampaignsTeam({
			archived: false,
			filter: filtersData
				? filtersData.filter(el => el.length > 0).join(' and ')
				: '',
			keywords: this.props.searchValue,
			orderby: this.props.orderby,
			skip:
				this.props.tableCampaignsStatisticsPage > 0
					? this.props.tableCampaignsStatisticsPage * CONSTS.PAGE_SIZE
					: 0
		})
		this.props.setLoaderStatistics(false)
	}
	getCampaignsTeam = async () => {
		const filtersData = this.createFiltersData()
		this.props.setLoaderStatistics(true)

		await teams.getCampaignsTeam({
			archived: false,
			filter: filtersData
				? filtersData.filter(el => el.length > 0).join(' and ')
				: '',
			keywords: this.props.searchValue,
			orderby: this.props.orderby,
			skip:
				this.props.tableCampaignsStatisticsPage > 0
					? this.props.tableCampaignsStatisticsPage * CONSTS.PAGE_SIZE
					: 0
		})

		this.props.setLoaderStatistics(false)
	}

	handleChangePage = async (event, newPage) => {
		const filtersData = this.createFiltersData()
		this.props.setLoaderStatistics(true)
		await teams.getCampaignsTeam({
			archived: this.props.archive,
			filter: filtersData
				? filtersData.filter(el => el.length > 0).join(' and ')
				: '',
			keywords: this.props.searchValue,
			orderby: this.props.orderby,
			skip: newPage > 0 ? newPage * CONSTS.PAGE_SIZE : 0
		})
		this.setState({ page: newPage })
		this.props.setLoaderStatistics(false)
	}
	handleClick = (event, name) => {
		const selectedIndex = this.state.selected.indexOf(name)
		let newSelected = []

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(this.state.selected, name)
		} else if (selectedIndex === 0) {
			this.setState({
				selectAllCampaignsValue: false
			})
			newSelected = newSelected.concat(this.state.selected.slice(1))
		} else if (selectedIndex === this.state.selected.length - 1) {
			this.setState({
				selectAllCampaignsValue: false
			})
			newSelected = newSelected.concat(this.state.selected.slice(0, -1))
		} else if (selectedIndex > 0) {
			this.setState({
				selectAllCampaignsValue: false
			})
			newSelected = newSelected.concat(
				this.state.selected.slice(0, selectedIndex),
				this.state.selected.slice(selectedIndex + 1)
			)
		}
		this.setState({
			selected: newSelected,
			selectedValues: newSelected.length
		})
	}

	handleResize = () => {
		const scrollbarWidth =
			this.wrapper.current.offsetWidth - this.wrapper.current.clientWidth

		if (scrollbarWidth > 0 && this.state.scrollBarWidth === false) {
			this.setState({ scrollBarWidth: true })
		}

		if (scrollbarWidth === 0 && this.state.scrollBarWidth === true) {
			this.setState({ scrollBarWidth: false })
		}
	}

	isSelected = name => this.state.selected.indexOf(name) !== -1

	onClearAllClick = () => {
		this.setState({
			selectAllCampaignsValue: false,
			selected: [],
			selectedValues: 0
		})
	}

	onClickStatus = id => {
		this.setState({
			campaignIdWithTip: id
		})
	}

	onSelectAllClick = () => {
		const newSelecteds = this.props.campaignsTeams.map(item => item.id)
		this.setState({
			selectAllCampaignsValue: true,
			selected: newSelecteds,
			selectedValues: this.props.campaignsTeamsCount
		})
	}

	onSelectAllPageClick = event => {
		this.setState({
			selectAllCampaignsValue: false,
			selectedValues:
				this.props.campaignsTeamsCount <= this.props.campaignsTeams.length
					? this.props.campaignsTeamsCount
					: this.props.campaignsTeams.length
		})

		if (event.target.checked) {
			let newSelected = this.props.campaignsTeams
			newSelected = newSelected.filter(
				item => !this.state.selected.includes(item)
			)

			this.setState({
				selected: this.state.selected.concat(newSelected).map((item, index) => {
					return item.id
				})
			})
			return
		}

		this.setState({
			selected: [],
			selectedValues: 0
		})
	}

	openLinkedInProfile = row => linkedInProfileOpener.open(row)

	render() {
		const getDataNameWidth = row =>
			(row?.name?.length > 30 &&
				document.documentElement.clientWidth > 1000 &&
				document.documentElement.clientWidth < 1537) ||
			(row?.name?.length > 40 &&
				document.documentElement.clientWidth > 1537 &&
				document.documentElement.clientWidth < 1746)

		const getDataClientWidth = row => {
			const lengthRow =
				row?.nickname?.length +
				(this.props.localAppProfile.personaId === row.id ? 3 : 0)

			return (
				(lengthRow > 13 &&
					document.documentElement.clientWidth > 1200 &&
					document.documentElement.clientWidth < 1535) ||
				(lengthRow > 22 &&
					document.documentElement.clientWidth > 1535 &&
					document.documentElement.clientWidth < 1744) ||
				(lengthRow > 30 &&
					document.documentElement.clientWidth > 1744 &&
					document.documentElement.clientWidth < 1919) ||
				(lengthRow > 35 &&
					document.documentElement.clientWidth > 1919 &&
					document.documentElement.clientWidth < 2132) ||
				(lengthRow > 43 &&
					document.documentElement.clientWidth > 2132 &&
					document.documentElement.clientWidth < 2401)
			)
		}
		const getDataClientWidthEmail = row => {
			return (
				(row.email.length > 19 &&
					document.documentElement.clientWidth > 1200 &&
					document.documentElement.clientWidth < 1535) ||
				(row.email.length > 28 &&
					document.documentElement.clientWidth > 1535 &&
					document.documentElement.clientWidth < 1744) ||
				(row.email.length > 36 &&
					document.documentElement.clientWidth > 1744 &&
					document.documentElement.clientWidth < 1919) ||
				(row.email.length > 41 &&
					document.documentElement.clientWidth > 1919 &&
					document.documentElement.clientWidth < 2132) ||
				(row.email.length > 49 &&
					document.documentElement.clientWidth > 2132 &&
					document.documentElement.clientWidth < 2401)
			)
		}
		return (
			<div
				className={`statistics-table-container ${
					this.props.campaignsTeamsCount > this.state.rowsPerPage
						? 'statistics-table-container-with-footer'
						: ''
				}`}
			>
				{this.state.campaignIdWithTip && (
					<div
						className='backdrop'
						onClick={() =>
							this.setState({
								campaignIdWithTip: ''
							})
						}
					/>
				)}

				<div
					className={clsx(
						css.filters,
						'app-scroll',
						this.state.filtersController && css.filtersOpen
					)}
				>
					<Button className={css.close} onClick={this.filtersControllerToggle}>
						<StackIcon icon='close' stroke='currentcolor' width={16} />
					</Button>

					<div className={css.filterWrapper}>
						<FiltersTeam
							clearFilterController={this.clearFilterController}
							clearFilterData={this.state.clearFilterData}
							createInitialState={this.createInitialState}
							filtersControllerByParams={this.filtersControllerByParams}
							filtersControllerToggle={this.filtersControllerToggle}
							from={'contacts'}
							getCampaignsTeam={this.getCampaignsTeam}
							initialFilters={this.state.initialFilters}
							initialFiltersLocale={this.state.initialFiltersLocale}
							isFiltering={this.state.isFiltering}
							keywords={this.props.searchValue}
							members={this.props.personas}
							orderby={this.props.orderby}
							page={this.state.page}
							personaId={this.props.localAppProfile.personaId}
							setFiltersTeams={value =>
								this.setState({
									filtersTeams: value
								})
							}
							setInitialFilters={value =>
								this.setState({
									initialFilters: value
								})
							}
							setInitialFiltersLocale={value =>
								this.setState({
									initialFiltersLocale: value
								})
							}
							setLoader={this.props.setLoaderStatistics}
							show={this.state.filtersController}
						/>
					</div>
				</div>
				<div className='hint-tooltip-wrapper'>
					<TableContainer className='table-body campaigns  with-checkboxs'>
						{this.props.loaderStatistics && !this.props.loader && (
							<div className='table-material-loader-wrapper-teams'>
								<CircularProgress
									classes={{ colorPrimary: 'material-loader' }}
									color='primary'
									size={60}
								/>
							</div>
						)}

						<CampaignFiltersTeams
							campaignsTeam={this.props.campaignsTeams}
							clearAllFilters={this.clearAllFilters}
							clearFilter={this.clearFilter}
							clearFilterController={this.clearFilterController}
							filtersController={this.state.filtersController}
							filtersControllerToggle={this.filtersControllerToggle}
							getCampaignsTeam={this.getCampaignsTeam}
							initialFilters={this.state.initialFilters}
							orderby={this.props.orderby}
							searchValue={this.props.searchValue}
							setInitialFilters={value =>
								this.setState({
									initialFilters: value
								})
							}
							setLoader={this.props.setLoaderStatistics}
							setPage={value => this.setState({ page: value })}
							setShowAll={value =>
								this.setState({
									showAll: value
								})
							}
							showAll={this.state.showAll}
						/>
						<Table
							aria-label='a dense table'
							className={'table'}
							size='small'
							style={{ tableLayout: 'auto' }}
						>
							<TableHead>
								<TableRow>
									<TableCell style={{ position: 'relative', width: '5%' }}>
										<div className='checkbox-container-header-teams'>
											<Checkbox
												checked={this.state.selected.length > 0}
												checkedIcon={
													<img
														alt='checkbox'
														src={
															this.props.campaignsTeams.length >
															this.state.selectedValues
																? partiallySelectedCheckboxIcon
																: selectedCheckboxIcon
														}
													/>
												}
												icon={
													<img alt='checkbox' src={notSelectedCheckboxIcon} />
												}
												indeterminate={
													this.props.campaignsTeams &&
													this.props.campaignsTeams.length <
														this.state.selected.filter(item =>
															this.props.campaignsTeams.includes(item)
														).length
												}
												indeterminateIcon={
													<img alt='checkbox' src={notSelectedCheckboxIcon} />
												}
												inputProps={{ 'aria-label': 'select all desserts' }}
												onChange={this.onSelectAllPageClick}
											/>
										</div>
									</TableCell>

									<TableCell
										className='name title-company '
										style={{ width: '26.8%' }}
									>
										{this.state.selected.length > 0 ? (
											<div className='selected-rows-statistics'>
												<>
													{this.state.selectedValues > 0 && (
														<div>
															<span className='select-text'>
																{this.state.selectedValues} of{' '}
																{this.props.campaignsTeamsCount} selected |{' '}
															</span>
															{!this.state.selectAllCampaignsValue && (
																<span
																	className='clear-all'
																	onClick={this.onSelectAllClick}
																>
																	Select all
																</span>
															)}

															{this.state.selectAllCampaignsValue && (
																<span
																	className='clear-all'
																	onClick={this.onClearAllClick}
																>
																	Clear
																</span>
															)}
														</div>
													)}
													<div className='background-button'>
														<ExportToCSVButton
															disabled={false}
															isLoading={false}
															onClick={() => {
																this.exportCampaigns()
															}}
															text='Export to CSV'
														/>
													</div>
												</>
											</div>
										) : (
											<div className='container-title-images'>
												<SortIconCampaigns
													idx={'name'}
													isSortedAsc={this.state.isIconActive}
													orderby={this.props.orderby}
													setIsSortedAsc={this.setActiveFilterIcon.bind(this)}
													setOrderby={this.props.setOrderby}
													sort={'name'}
													text={'Campaign'}
												/>
											</div>
										)}
									</TableCell>
									<TableCell style={{ width: '20%' }}>
										<div className='stats'>
											{' '}
											<SortIconCampaigns
												idx={'persona_id'}
												isSortedAsc={this.state.isIconActive}
												orderby={this.props.orderby}
												setIsSortedAsc={this.setActiveFilterIcon.bind(this)}
												setOrderby={this.props.setOrderby}
												sort={'persona_id'}
												text={'Account'}
											/>
										</div>
									</TableCell>
									<TableCell className='stats-team' style={{ width: '7%' }}>
										Status
									</TableCell>
									<TableCell className='contacts' style={{ width: '6.2%' }}>
										<div className='container-title-images'>
											<SortIconCampaigns
												idx={'invitation_sent'}
												isSortedAsc={this.state.isIconActive}
												orderby={this.props.orderby}
												setIsSortedAsc={this.setActiveFilterIcon.bind(this)}
												setOrderby={this.props.setOrderby}
												sort={'invitation_sent'}
												text={'Invites sent'}
											/>
										</div>
									</TableCell>
									<TableCell className='contacts' style={{ width: '8%' }}>
										<div className='container-title-images'>
											<SortIconCampaigns
												idx={'acceptance_rate'}
												isSortedAsc={this.state.isIconActive}
												orderby={this.props.orderby}
												setIsSortedAsc={this.setActiveFilterIcon.bind(this)}
												setOrderby={this.props.setOrderby}
												sort={'acceptance_rate'}
												text={'Acceptance rate'}
											/>
										</div>
									</TableCell>
									<TableCell className='contacts' style={{ width: '7%' }}>
										<div className='container-title-images'>
											<SortIconCampaigns
												idx={'messages_sent'}
												isSortedAsc={this.state.isIconActive}
												orderby={this.props.orderby}
												setIsSortedAsc={this.setActiveFilterIcon.bind(this)}
												setOrderby={this.props.setOrderby}
												sort={'messages_sent'}
												text={'Messages sent'}
											/>
										</div>
									</TableCell>

									<TableCell
										className='steps'
										style={{
											width: '6%'
										}}
									>
										<div className='container-title-images'>
											<SortIconCampaigns
												idx={'reply_rate'}
												isSortedAsc={this.state.isIconActive}
												orderby={this.props.orderby}
												setIsSortedAsc={this.setActiveFilterIcon.bind(this)}
												setOrderby={this.props.setOrderby}
												sort={'reply_rate'}
												text={'Reply rate'}
											/>
										</div>
									</TableCell>

									<TableCell className='date-reply' style={{ width: '9%' }}>
										<div className='container-title-images-teams'>
											<SortIconCampaigns
												flexEnd={true}
												idx={'created'}
												isSortedAsc={this.state.isIconActive}
												orderby={this.props.orderby}
												scrollBarWidth={this.state.scrollBarWidth}
												setIsSortedAsc={this.setActiveFilterIcon.bind(this)}
												setOrderby={this.props.setOrderby}
												sort={'created'}
												text={'Created'}
											/>
										</div>
									</TableCell>
								</TableRow>
							</TableHead>
							<TableBody className='app-scroll' ref={this.wrapper}>
								{this.props.campaignsTeams.map((row, index) => (
									<TableRow className='table-row-teams' key={row.id}>
										<TableCell padding='checkbox' style={{ width: '5%' }}>
											<div className='checkbox-container-teams'>
												<Checkbox
													checked={this.isSelected(row.id)}
													checkedIcon={
														<img alt='checkbox' src={selectedCheckboxIcon} />
													}
													icon={
														<img alt='checkbox' src={notSelectedCheckboxIcon} />
													}
													inputProps={{
														'aria-labelledby': `enhanced-table-checkbox-${index}`
													}}
													onClick={event => this.handleClick(event, row.id)}
												/>
											</div>
										</TableCell>

										<TableCell
											className='name semi-bold title-company'
											scope='row'
											style={{ width: '26.8%' }}
										>
											<div className='name-text-container'>
												<div className='wrapper-performed-bar'>
													<TooltipCustom
														arrow={true}
														title={getDataNameWidth(row) ? row.name : ''}
													>
														<p
															className={
																getDataNameWidth(row)
																	? 'ellipsis'
																	: 'left-list-text'
															}
														>
															{row.name}
														</p>
													</TooltipCustom>

													{campaignUtils.isActive(row.status) ? (
														<div className='flex-container-performed-progress-campaigns'>
															<div className='performed-progress-campaigns'>
																<div
																	className={clsx(
																		'performed-bar',
																		campaignConst.statusToCN[row.status]
																	)}
																	style={{
																		width: `${
																			row.statistics.started_count &&
																			row.target_audience_count
																				? (
																						row.statistics.started_count /
																							row.target_audience_count
																					) * 100
																				: '0'
																		}%`
																	}}
																>
																	&nbsp;
																</div>
															</div>

															<div className='performed-bar-value'>
																<div className='performed-bar-text'>
																	{row.statistics.started_count}
																</div>
																<div className='performed-bar-text'>
																	{row.statistics.in_queue_count}
																</div>
															</div>
														</div>
													) : (
														<div className='flex-container'>
															<div className='team-contacts-text'>
																{row.target_audience_count ? (
																	`Contacts: ${row.target_audience_count}`
																) : (
																	<PersonLink
																		className='add-contacts-button-team'
																		href={`/campaigns/${row.id}/contacts`}
																		id={row.personaId}
																	>
																		Add contacts
																	</PersonLink>
																)}
															</div>
															<div>
																{row.steps.length === 0 ? (
																	<PersonLink
																		className='add-contacts-button-team'
																		href={`/campaigns/${row.id}/tune`}
																		id={row.personaId}
																	>
																		Add actions
																	</PersonLink>
																) : (
																	<div className='team-contacts-text'>
																		{`${row.steps[0].name} `}
																		{row.steps.length - 1 > 0
																			? `(+${row.steps.length - 1})`
																			: ''}
																	</div>
																)}
															</div>
														</div>
													)}
												</div>
											</div>
										</TableCell>
										<TableCell className='account' style={{ width: '20%' }}>
											<div className='account-container-team'>
												<img
													alt='avatar'
													className='avatar'
													src={row.avatar ? row.avatar : avatarSvg}
												/>
												<div className='ellipsis'>
													<div className='flex-wrapper-team-accent'>
														{(row.entityId || row.publicIdentifier) && (
															<a
																href='/#'
																onClick={async e => {
																	e.preventDefault()
																	await this.openLinkedInProfile(row)
																}}
																rel='noopener noreferrer'
																target='_blank'
															>
																<TooltipCustom
																	arrow={true}
																	title='Open LinkedIn profile'
																>
																	<img
																		alt='link svg'
																		className='link-img-accent '
																		src={linkSvgGold}
																	/>
																</TooltipCustom>
															</a>
														)}
														<div className={'text-box-wrapper'}>
															<div>
																<div className='edit-title '>
																	<div
																		className={
																			getDataClientWidth(row)
																				? 'text-box-wrapper-hover '
																				: 'text-box-wrapper'
																		}
																	>
																		<TooltipCustom
																			arrow={true}
																			title={
																				getDataClientWidth(row)
																					? row.nickname
																					: ''
																			}
																		>
																			<div className='text-page first-name semi-bold ellipsis'>
																				{row.nickname}
																			</div>
																		</TooltipCustom>
																	</div>
																	{this.props.localAppProfile.personaId ===
																		row.personaId && '(you)'}
																</div>
															</div>
														</div>
													</div>

													<div
														className={
															getDataClientWidthEmail(row)
																? 'text-box-wrapper-hover'
																: 'text-box-wrapper'
														}
													>
														<TooltipCustom
															arrow
															title={
																getDataClientWidthEmail(row) ? row.email : ''
															}
														>
															<p className={'email-team ellipsis'}>
																{row.email}
															</p>
														</TooltipCustom>
													</div>
												</div>
											</div>
										</TableCell>
										<TableCell className='contacts' style={{ width: '7%' }}>
											{buildStatus({
												campaignIdWithTip: this.state.campaignIdWithTip,
												id: row.id,
												onClick: this.onClickStatus,
												pauseReasonStatus: row.pause_reason,
												status: row.status
											})}
										</TableCell>
										<TableCell
											className='contacts   text-accent'
											style={{ width: '6.2%' }}
										>
											{row.statistics.invitation_sent}
										</TableCell>
										<TableCell className='contacts' style={{ width: '8%' }}>
											<div className='start-wrapper-accent'>
												<div className='start-end-date text-accent'>
													{row.statistics.acceptance_rate !== null
														? `${functions
																.roundToDecimal(row.statistics.acceptance_rate)
																.toString()}%`
														: '...'}
												</div>
											</div>
										</TableCell>
										<TableCell
											className='contacts   text-accent'
											style={{ width: '7%' }}
										>
											{row.statistics.messages_sent}
										</TableCell>

										<TableCell
											className={
												this.state.scrollBarWidth
													? 'common-wrapper-scroll-team'
													: 'common-wrapper-team'
											}
										>
											<div
												style={{
													display: 'flex'
												}}
											>
												<div
													className={`contacts  text-accent ${
														this.state.scrollBarWidth
															? 'width-with_scroll-percent'
															: 'width-with-out_scroll-percent'
													}`}
												>
													{row.statistics.reply_rate !== null
														? `${functions
																.roundToDecimal(row.statistics.reply_rate)
																.toString()}%`
														: '...'}
												</div>
												<div
													className={
														this.state.scrollBarWidth
															? 'width-with_scroll-teams'
															: 'width-with-out_scroll-teams'
													}
												>
													<div className='start-end-date-teams'>
														{`${
															row.created
																? functions.parseDateToDMY(row.created, '/')
																: '...'
														}`}
													</div>
													<div className='btn-group position-button-group-team'>
														<TooltipCustom arrow={true} title='Open campaign'>
															<PersonLink
																className='btn-row info'
																href={`/campaigns/${row.id}`}
																id={row.personaId}
															>
																<img alt='arrowIcon' src={iconArrow} />
															</PersonLink>
														</TooltipCustom>
													</div>
												</div>
											</div>
										</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</TableContainer>
					{this.props.campaignsTeamsCount > this.state.rowsPerPage && (
						<div
							className={
								this.props.campaignsTeamsCount &&
								this.props.campaignsTeamsCount > this.state.rowsPerPage
									? 'table-footer-accent'
									: 'table-footer'
							}
						>
							<PaginationWrapper
								component='div'
								count={this.props.campaignsTeamsCount}
								onPageChange={this.handleChangePage}
								page={this.state.page}
								rowsPerPage={this.state.rowsPerPage}
								rowsPerPageOptions={[]}
							/>
						</div>
					)}
				</div>

				<InformationalTip />
			</div>
		)
	}

	setActiveFilterIcon(key, value) {
		this.setState({
			isIconActive: {
				...{
					acceptance_rate: true,
					invitation_sent: true,
					messages_sent: true,
					name: true,
					persona_id: true,
					reply_rate: true,
					started: true,
					started_count: true
				},
				[key]: value
			}
		})
	}
}

const mapStateToProps = (state: RootState) => ({
	activity: state.activity,
	appProfile: state.app.appProfile,
	campaignsTeamsCount: state.campaignsTeams.campaignsTeamsCount,
	pageContentLoader: state.app.pageContentLoader,
	searchValue: state.campaignsTeams.searchValueTeams,
	signInUnderTeamMember: appSelectors.signInUnderTeamMember(state),
	subscription: state.app.subscription,
	teams: state.campaignsTeams
})

export default connect(mapStateToProps)(TeamCampaignStatistics)
